module.exports = __webpack_public_path__ + "static/img/einforma_logo.8b7ebd4f.svg";